import axios from '@/utils/axios'

let cache = null
let cacheTime = 0
let inFlight = null
const TTL = 30 * 1000

export async function getMyFollowups(force = false) {
  const now = Date.now()

  if (force) { cache = null; inFlight = null }

  if (cache && (now - cacheTime) < TTL) return cache

  if (inFlight) return inFlight

  inFlight = axios.get('/reminders/my/created')
    .then(res => {
      cache = res.data.data || []
      cacheTime = Date.now()
      inFlight = null
      return cache
    })
    .catch(err => { inFlight = null; throw err })

  return inFlight
}